import { EventContentStatus, QuizContentSubtype } from 'globalTypes'

import filter from 'lodash/filter'
import get from 'lodash/get'

import MoveTo from '../Collection/MenuItems/MoveTo'
import AddToCalendarLinks from './MenuItems/AddToCalendarLinks'
import Associate from './MenuItems/Associate'
import CancelEvent from './MenuItems/CancelEvent'
import Download from './MenuItems/Download'
import Edit from './MenuItems/Edit'
import Evaluations from './MenuItems/Evaluations'
import LinkRelated from './MenuItems/LinkRelated'
import Note from './MenuItems/Note'
import Presences from './MenuItems/Presences'
import Remove from './MenuItems/Remove'
import RemovePageProfile from './MenuItems/RemovePageProfile'
import Statistics from './MenuItems/Statistics'

export const getMenuItems = (
  { __typename, canManage, id, slug, visibility, parent_folder_id, ...data },
  removePositionTop?,
  userIsCreator?,
  path?
) => {
  const isFolderPage = path ? /^\/f\/[^/]+/.test(path) : false
  const isProfilePage = path ? /^\/profile(\/|$)/.test(path) : false
  const canRemove =
    (__typename !== 'EventContent' ||
      (__typename === 'EventContent' &&
        ((get(data, 'eventStatusForMenu') as EventContentStatus) === 'past' ||
          (get(data, 'eventStatusForMenu') as EventContentStatus) ===
            'expired' ||
          (get(data, 'isCurrentUserRegistered') as Boolean) === false))) &&
    (userIsCreator || !isFolderPage)

  const canCancelEvent =
    __typename === 'EventContent' &&
    canManage &&
    ((get(data, 'status') as EventContentStatus) === 'scheduled' ||
      (get(data, 'status') as EventContentStatus) === 'in_progress')

  const canAssociate = canManage

  return filter([
    removePositionTop && canRemove && !isProfilePage ? (
      <Remove
        canManage={canManage}
        id={id}
        key={`remove_${id}`}
        typename={__typename}
        visibility={visibility}
      />
    ) : null,

    userIsCreator && isProfilePage ? (
      <RemovePageProfile id={id} typename={__typename} />
    ) : null,

    canCancelEvent ? <CancelEvent id={id} key={`cancel_event_${id}`} /> : null,

    canManage && <Statistics key={`statistics_${slug}`} slug={slug} />,

    Boolean(canManage) ? <Edit key={`edit_${id}`} id={id} /> : null,

    Boolean(canAssociate) ? (
      <Associate key={`associate_${id}`} visibility={visibility} id={id} />
    ) : null,

    Boolean(__typename === 'EventContent' && canManage) ? (
      <LinkRelated key={`related_${id}`} id={id} />
    ) : null,

    Boolean(
      __typename === 'PdfContent' && canManage && get(data, 'canDownload')
    ) ? (
      <Download url={get(data, 'url')} title={get(data, 'title')} />
    ) : null,

    Boolean(
      __typename === 'QuizContent' &&
        canManage &&
        get(data, 'quizSubtypeForMenu') !==
          QuizContentSubtype.self_assessment_test
    ) ? (
      <Evaluations key={`evaluations_${id}`} id={id} />
    ) : null,

    Boolean(__typename === 'EventContent') ? (
      <AddToCalendarLinks key={`add_to_calendar_${id}`} id={id} />
    ) : null,

    Boolean(__typename === 'EventContent' && canManage) ? (
      <Presences key={`presences_${id}`} id={id} />
    ) : null,

    <Note key={`note_${id}`} id={id} />,
    userIsCreator && __typename !== 'Folder' ? (
      <MoveTo
        key={`move_${id}`}
        element={{ id, __typename, parent_folder_id, visibility }}
      />
    ) : null,

    !removePositionTop && canRemove && !isProfilePage ? (
      <Remove
        canManage={canManage}
        id={id}
        key={`remove_${id}`}
        typename={__typename}
        visibility={visibility}
      />
    ) : null,
  ])
}
